const DARK_CLASS = 'theme__dark';
const FOOTER_CLASS = 'footer_v2';

export default function styleSiteFooter(injectDarkTheme: boolean) {
  const footer = document.querySelector(`.${FOOTER_CLASS}`);

  if (!footer) {
    return;
  }

  if (injectDarkTheme) {
    footer.classList.add(DARK_CLASS);
  } else {
    footer.classList.remove(DARK_CLASS);
  }
}
